export default function HomeRoute() {
	return (
		<main
			className="container z-10 flex flex-1 items-end bg-cover bg-center bg-no-repeat"
			style={{ backgroundImage: `url('/img/home.png')` }}
		>
			<div className="mx-auto mt-auto max-w-4xl py-32 sm:py-48 lg:py-56">
				<div className="text-center">
					<h1 className="text-5xl font-bold tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl">
						FIONA & KOAN
					</h1>
					<p className="mt-6 text-2xl leading-8 text-white md:text-3xl lg:text-4xl">
						31 August 2024 | Villa Montalvo, CA
					</p>
				</div>
			</div>
		</main>
	)
}
